import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import queryString from "query-string";
import isEmpty from '../../validation/is-empty';
import { getFaq } from "../../actions/faqActions";
import './faq.css';

class FaqHome extends Component {
  
  componentDidMount() {
    this.props.getFaq(
      decodeURIComponent(this.props.location.search)
    );
    document.title = "遊戲FAQ";
    document.body.style = "padding: 10px; margin: 10px; height: 100%; width: 100%; background-color: #FEF7DE; color: #5C5C5C;";
  }

  render() {
    const { faq } = this.props;
    const search_values = queryString.parse(this.props.location.search);
    let content = "";
    let backButton = "";
    
    if (isEmpty(faq))
      content = "";
    else if (isEmpty(faq.content))
      content = faq;
    else
    {
      content = String(faq.content).replaceAll('border="1"', 'class="faq-table"');
      backButton = `<input class="btn btn-large btn-inverse back_button" onclick="location.href='/faq?site=${search_values.site}';" type="submit" value="首頁" /><hr />`;
    }

    return (
      <div id="content-faq">
	      <div class="faq-ins">
          {isEmpty(backButton) ? ( "" ) : ( <div dangerouslySetInnerHTML={{ __html: backButton }} /> )}
          <div dangerouslySetInnerHTML={{ __html: content }} />
        </div>
      </div>
    );
  }
}

FaqHome.propTypes = {
  getFaq: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => (
  {
  faq: state.faq.faq,
});

export default connect(mapStateToProps, { getFaq })(FaqHome);